const ApiName = window.APP_CONFIG?.API_URL || "https://localhost:44313";
export default ApiName;
//git updated